export default function (...args)	// length ou lengths (ex.: sku(6), sku(6,10,12), sku([6,10,12]))
{
	const lengths = Array.isArray(args[0]) ? args[0] : args.filter(Number.isInteger);
	const pattern = lengths.length > 1
		? lengths.map(n => `[A-NP-Z0-9]{${n}}`).join('|')
		: `[A-NP-Z0-9]{${lengths[0] || args[0]}}`;
	return {
		type: 'sku',
		regex: new RegExp(`^(${pattern})$`),
		filter: /[]/g,
	};
}

